import { useSyncExternalStore } from 'react';
import { authService } from '../../services/authService';

const subscribe = (listener: () => void) => typeof authService.subscribe === 'function' ? authService.subscribe(listener) : () => {};
const getSnapshot = () => {
  const state = typeof authService.getState === 'function' ? authService.getState() : undefined;
  const user = state?.user;
  return JSON.stringify([
    typeof authService.getSessionRevision === 'function' ? authService.getSessionRevision() : 0,
    state?.isAuthenticated ?? false,
    user?.id ?? null,
    user?.tenantId ?? null,
    [...(user?.roles ?? [])].sort(),
    [...(user?.permissions ?? [])].sort(),
  ]);
};

export function usePlatformIdentity() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}